import "./configuration.scss";
import { Context } from "../../Reducers/Store";
import React, { useEffect, useContext, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ModalComponent from "../ModalComponent";
import Profile from "../Profile/profile";
import Password from "../Password/password";
import Notifications from "../Notifications/notifications";
import Team from "../Team/team";
import DeleteAccount from "../DeleteAccount/deleteaccount";
import ManageSubscriptionConfig from "../ManageSubscriptionConfig/managesubscriptionconfig";
import Applications from "../Applications/applications";
import jwt_decode from "jwt-decode";
import AlertComponent from "../AlertComponent";
import { useNavigate } from "react-router-dom";

function Configuration(props) {
  const [state, dispatch] = useContext(Context);
  const [active, setActive] = useState(1);
  const [currentProfile, setCurrentProfile] = useState(null);
  const [role, setRole] = useState(null);
  const [passwordSignin, setPasswordSignin] = useState(false);
  const [jwtInfo, setJwtInfo] = useState(false);
  let navigate = useNavigate();


  const handleClose = (show) => {
    setActive(1);
    props.setShowConfig(show);
  };

  const handleLogout = () => {
    return AlertComponent(
      "Confirm",
      "Are you sure you want to quit?",
      { icon: `warning`, showConfirmButton: true, showCancelButton: true, cancelButtonText: "No" },
      () => {
        handleClose(false);
        dispatch({ type: "SET_LOGGED", payload: null });
        dispatch({ type: "SET_HUB", payload: null });
        navigate("/", { replace: false });
      },
      false,
      "Yes",
      () => {
        setActive(1);
      }
    );
  };

  const configOptions = [
    { key: 1, id: 1, description: "Edit Profile", mainClass: "edit-profile-menu", element: <Profile setCurrentProfile={setCurrentProfile} /> },
    { key: 2, id: 2, description: "Password", mainClass: "password-menu", element: <Password jwtInfo={jwtInfo} />, hideOption: !passwordSignin },
    { key: 3, id: 3, description: "Notification", mainClass: "notification-menu", element: <Notifications />, hideOption: true },
    { key: 4, id: 4, description: "Chat Export", mainClass: "chat-export-menu", hideOption: true },
    { key: 5, id: 5, description: "Applications", mainClass: "applications-menu", hideOption: currentProfile?.subscription?.plan === `Free`, element: <Applications /> },
    { key: 6, id: 6, description: "Team", mainClass: "team-menu", hideOption: role !== "Owner", element: <Team currentProfile={currentProfile} /> },
    {
      key: 7,
      id: 7,
      description: "Manage Subscription",
      mainClass: "manage-subscription-menu",
      divider: true,
      hideOption: role !== "Owner",
      element: <ManageSubscriptionConfig currentProfile={currentProfile} />,
    },
    { key: 8, id: 8, description: "Logout", mainClass: "logout-menu", element: <></>, customClick: handleLogout },
    { key: 9, id: 9, description: "Delete Account", mainClass: "delete-menu", element: <DeleteAccount handleSuccess={handleClose} /> },
  ];

  const authLocalStorage = localStorage.getItem("auth");
  const authJson = JSON.parse(authLocalStorage);

  useEffect(() => {
    if (authLocalStorage) {
      const jwtInfoDecoded = jwt_decode(authJson.token);
      setJwtInfo(jwtInfoDecoded);
      setPasswordSignin(jwtInfoDecoded?.firebase?.sign_in_provider === "password");
    }
  }, [authLocalStorage]);

  useEffect(() => {
    if (currentProfile) {
      setRole(currentProfile?.subscription?.role);
    }
  }, [currentProfile]);

  const handleActive = (element, hasElement) => {
    if (hasElement) {
      setActive(element);
    }
  };

  const handleCustomClick = (x) => {
    if (x.customClick) {
      x.customClick();
    }
  };

  const content = (
    <Container className="configuration-container">
      <Row className="configuration-content">
        <Col md={4}>
          {configOptions.map((x, index) => {
            return (
              <div className={`${x.mainClass} ${x.divider ? `configuration-divisor` : ``}`} onClick={() => handleCustomClick(x)}>
                <div
                  key={`config_key_${index}`}
                  className={`configuration-element ${!x.element ? `disabled configuration-disabled` : ``} ${x.hideOption ? `d-none` : ``}`}
                  onClick={() => handleActive(x.id, x.element)}
                >
                  <p className={`${active === x.id ? `configuration-active` : ``}`}>{x.description}</p>
                </div>
              </div>
            );
          })}
        </Col>
        <Col md={8}>
          {configOptions.map((x) => {
            return active === x.id && x.element;
          })}
        </Col>
      </Row>
    </Container>
  );

  const closeContainerStyle = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    width: 40,
    height: 40,
    backgroundColor: "#F3F5F7",
    position: "absolute",
    marginTop: 20,
    marginRight: -720,
    borderRadius: 40,
  };
  return (
    <ModalComponent
      styleCloseContainer={closeContainerStyle}
      className="modal-container"
      data={content}
      modalIsOpen={props.showConfig}
      setModalIsOpen={handleClose}
      showCloseText={false}
    />
  );
}

export default Configuration;
